import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import { SidebarNav } from './components';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { IconButton } from '@mui/material';
import { getLoggedInUserProfile } from '../../../../apps/user/Users/UserService';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface Props {
  // eslint-disable-next-line @typescript-eslint/ban-types
  onClose: () => void;
  open: boolean;
  variant: 'permanent' | 'persistent' | 'temporary' | undefined;
}

const Sidebar = ({ open, variant, onClose }: Props): JSX.Element => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [userRole, setUserRole] = useState('');
  const theme = useTheme();
  useEffect(() => {
    getLoggedInUserProfile()
      .then((response) => {
        setFirstName(response.data.firstName);
        setLastName(response.data.lastName);
        let role = response.data.authorities[0].authority;
        if (role.startsWith('ROLE_')) {
          role = role.substring(5);
        }
        role = role.charAt(0).toUpperCase() + role.substring(1).toLowerCase();
        setUserRole(role);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <Drawer
      anchor="left"
      onClose={() => onClose()}
      open={open}
      variant={variant}
      sx={{
        '& .MuiPaper-root': {
          width: '100%',
          maxWidth: 256,
          top: { xs: 0, md: 71 },
          height: { xs: '100%', md: 'calc(100% - 71px)' },
          background: theme.palette.alternate.main,
        },
      }}
    >
      <Box
        paddingX={1}
        paddingTop={1}
        paddingBottom={1}
        display="flex"
        alignItems="center"
      >
        <Box marginRight={1}>
          <IconButton>
            <AccountCircleOutlinedIcon sx={{ fontSize: 60 }} />
          </IconButton>
        </Box>
        <Box>
          <Typography variant="subtitle1" noWrap>
            {firstName} {lastName}
          </Typography>
          <Typography variant="body2" color="textSecondary" noWrap>
            {userRole}
          </Typography>
        </Box>
      </Box>
      <SidebarNav />
    </Drawer>
  );
};

export default Sidebar;
